import Navbar from "../../components/Navbar";
import HeroText from "./HeroText";
import AnimatedBg from "./AnimatedBg";
function Hero() {
  return (
    <>
      <Navbar />
      {/* hero section */}
      <div className="relative w-full overflow-x-hidden">
        <AnimatedBg />
        {/* content */}
        <section className="  min-h-[85vh] el-container-xl flex justify-center items-center z-10">
          <div className=" flex justify-center flex-col text-center max-w-[1054px]  ">
            <HeroText />
          </div>
        </section>
      </div>
    </>
  );
}

export default Hero;
